import React, { useState, useEffect, useMemo } from "react"
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { APIURL } from '../../config'
import axios from 'axios'
import moment from "moment"
import {
    DataGridPro
} from '@mui/x-data-grid-pro';
import "./SummaryTable.css"
import CircularProgress from '@mui/material/CircularProgress';

export default function TimesheetsSummaryTable(props) {

    const [rowSelectionModel, setRowSelectionModel] = useState({ type: 'include', ids: new Set() });
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [currentPageRows, setCurrentPageRows] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null); // Store currently loaded rows

    // DataSource for lazy loading following MUI X documentation
    const dataSource = useMemo(() => ({
        getRows: async (params) => {
            try {
                if (!props.currentPayPeriod || !props.company_id) {
                    return { rows: [], rowCount: 0 };
                }

                const { start, end, sortModel, filterModel, paginationModel } = params;

                console.log(paginationModel);
                
                
                const response = await axios.get(`${APIURL}/time_sheet/v2/summary`, {
                    params: {
                        company_id: props.company_id,
                        pay_period_id: props.currentPayPeriod.pay_period_id,
                        startIndex: start,
                        endIndex: end,
                        sortModel: sortModel ? JSON.stringify(sortModel) : undefined,
                        filterModel: filterModel ? JSON.stringify(filterModel) : undefined,
                        paginationModel: paginationModel ? JSON.stringify(paginationModel) : undefined,
                        ...(props.user.type.toLowerCase().includes('manager') && { manager_employee_id: props.user.emp_id })
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        Authorization: 'Bearer ' + window.localStorage.getItem('Fw4_access_Token')
                    }
                });

                // Handle the response structure from the enhanced backend
                const responseData = response.data;
                const rows = responseData.rows || responseData || []; // Support both new and legacy response formats
                const totalCount = responseData.rowCount || responseData.totalCount || rows.length;
                
                console.log(`DataSource - PaginationModel:`, paginationModel);
                console.log(`DataSource - Start: ${start}, End: ${end}, Total: ${totalCount}`);

                console.log('Raw Rows:', rows);

                let rowId = 0;

                const formattedRows = rows.map((row) => ({
                    id: rowId++, // Use timesheet_id as unique identifier instead of emp_id
                    emp_id: row.emp_id, // Keep emp_id as a separate field
                    timesheet_id: row.time_sheet_id,
                    employee_name: row.employee_name,
                    total_hours: parseFloat(row.total_hours).toFixed(2),
                    timesheet_status: row.time_sheet_status ? row.time_sheet_status : 'Timesheet Not Created',
                    submitted_on: row.submitted_on ? moment(row.submitted_on.replace(/Z/g, "")).format('MMM DD, YYYY') : 'N/A'
                }));

                console.log('Formatted Rows:', formattedRows);
                
                // Store the current page rows for "select all" functionality
                setCurrentPageRows(formattedRows);

                return { rows: formattedRows, rowCount: totalCount };
            } catch (error) {
                console.error('Error fetching timesheet summary data:', error);
                return { rows: [], rowCount: 0 };
            }
        }
    }), [props.currentPayPeriod, props.company_id, props.user]);

    // Reset selection when pay period changes
    useEffect(() => {
        setRowSelectionModel({ type: 'include', ids: new Set() });
    }, [props.currentPayPeriod]);

    const columns = [
        { field: 'emp_id', headerName: 'Employee ID', flex: 1, hide:true },
        { field: 'timesheet_id', headerName: 'Timesheet ID', flex: 1, hide:true },
        { field: 'employee_name', headerName: 'Employee Name', flex: 1, sortable: true },
        { field: 'total_hours', headerName: 'Total Hours', flex: 1, sortable: true },
        { field: 'timesheet_status', headerName: 'Timesheet Status', flex: 1, sortable: true },
        { field: 'submitted_on', headerName: 'Submitted On', flex: 1, sortable: true },
        {
            field: 'actions',
            headerName: 'Actions',
            sortable: false,
            renderCell: (params) => {
                return (
                    <div>
                        <button style={{ borderRadius: 20 }} className='btn btn-sm btn-info' onClick={() => props.setCurrentEmployeeById(params.row.emp_id)}> <i className="far fa-edit"></i> </button>
                    </div>
                )
            }
        }
    ];

    const getPayrollStatus = () => {
        if(props.currentPayPeriod){
            return <strong>{`Pay period for ${props.currentPayPeriod.payroll_type.toLowerCase()} starting on ${moment(props.currentPayPeriod.start_date.replace(/Z/g, "")).format('ll')}`}</strong>;
        }
        return <strong>{`Could Not Find Pay Cycle`}</strong>
    }

    async function handleBulkAction(action) {
        let selectedRowIds = [];
        
        if (rowSelectionModel.type === 'include') {
            // Normal selection - use the IDs directly
            selectedRowIds = Array.from(rowSelectionModel.ids || new Set());
        } else if (rowSelectionModel.type === 'exclude') {
            // "Select all" was clicked - use currently loaded rows on this page
            const excludedIds = rowSelectionModel.ids || new Set();
            selectedRowIds = currentPageRows
                .map(row => row.emp_id) // Use emp_id for bulk actions
                .filter(id => !excludedIds.has(id));
            
            console.log(`Select all on current page: ${selectedRowIds.length} rows selected`);
        }

        if (selectedRowIds.length === 0) {
            alert("Please select at least one employee to perform bulk actions.");
            return;
        }

        // For lazy loading, we need to get the full row data for selected IDs
        for (let i = 0; i < selectedRowIds.length; i++) {
            const empId = selectedRowIds[i];
            
            // Get timesheet info for the employee
            try {
                const timesheetResponse = await axios.get(`${APIURL}/time_sheet`, {
                    params: {
                        company_id: props.company_id,
                        pay_period_id: props.currentPayPeriod.pay_period_id,
                        employee_id: empId,
                    }
                });

                const timesheetData = timesheetResponse.data[0];
                
                // Handle generateMissingTimesheets action separately since it needs to work with missing timesheets
                console.log(props.currentPayPeriod.pay_period_id)
                console.log(timesheetData);
                if (action === "generateMissingTimesheets") {
                    if (!timesheetData) {
                        // Create a new timesheet for the employee
                        console.log(`Creating missing timesheet for employee ${empId}`);
                        await axios.post(`${APIURL}/time_sheet`, {
                            company_id: props.company_id,
                            emp_id: empId,
                            pay_period_id: props.currentPayPeriod.pay_period_id,
                            time_sheet_status: "ACTIVE"
                        });
                    }
                    continue;
                }
                
                // For other actions, skip if no timesheet exists
                if (!timesheetData) continue;

                let updatePayload = {
                    company_id: props.company_id,
                    emp_id: empId,
                    pay_period_id: props.currentPayPeriod.pay_period_id,
                    time_sheet_id: timesheetData.time_sheet_id,
                };

                if (action === "approve" && timesheetData.time_sheet_status === "SUBMITTED") {
                    await axios.put(`${APIURL}/time_sheet`, {
                        ...updatePayload,
                        time_sheet_status: "APPROVED",
                        submitted_on: null,
                        approved_on: moment().toISOString(),
                        approved_by: props.user.emp_id,
                    });
                }
                if (action === "unapprove" && timesheetData.time_sheet_status === "APPROVED") {
                    await axios.put(`${APIURL}/time_sheet`, {
                        ...updatePayload,
                        time_sheet_status: "SUBMITTED",
                        submitted_on: null,
                        approved_on: null,
                        approved_by: null,
                    });
                }
                if (action === "lock" && timesheetData.time_sheet_status === "APPROVED") {
                    await axios.put(`${APIURL}/time_sheet`, {
                        ...updatePayload,
                        time_sheet_status: "ARCHIVED",
                        submitted_on: null,
                        approved_on: null,
                        approved_by: null,
                    });
                }
                if (action === "unlock" && timesheetData.time_sheet_status === "ARCHIVED") {
                    await axios.put(`${APIURL}/time_sheet`, {
                        ...updatePayload,
                        time_sheet_status: "APPROVED",
                        submitted_on: null,
                        approved_on: moment().toISOString(),
                        approved_by: props.user.emp_id,
                    });
                }
            } catch (error) {
                console.error(`Error processing bulk action for employee ${empId}:`, error);
            }
        }
        
        // Clear selection and trigger data refresh by recreating dataSource
        setRowSelectionModel({ type: 'include', ids: new Set() });
        // Force a re-render which will trigger the dataSource to refetch current data
        setPaginationModel(prev => ({ ...prev }));

        //refresh data in parent component
        props.refreshData();
    }

    return (
        <div style={{width: '100%' }}>
            <div
                id="timesheets-summarytable-weeknavigation"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: 16,
                    gap: 4,
                    padding: '8px',
                    backgroundColor: '#fafafa'
                }}
            >
                <div style={{ flex: 1, minWidth: 200 }}>
                    {getPayrollStatus()}
                </div>

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 3,
                    gap: 16,
                }}>
                    <Button
                        className="FW-Button"
                        style={{ whiteSpace: 'nowrap', width: '80px', paddingTop: '2px', marginBottom: '8px' }}
                        id="previousweekbutton"
                        onClick={() => props.handlePreviousPayPeriod()}
                    >
                        {'<<'}
                    </Button>
                    {props.currentPayPeriod && (
                        <h2 id="current-week-display" style={{ margin: '0 16px', fontSize: 22 }}>
                            {moment(props.currentPayPeriod.start_date.replace(/Z/g, "")).format("MMM[ ]DD")} - {moment(props.currentPayPeriod.end_date.replace(/Z/g, "")).format("MMM[ ]DD")}, {moment(props.currentPayPeriod.start_date.replace(/Z/g, "")).format("YYYY")}
                        </h2>
                    )}
                    <Button
                        className="FW-Button"
                        style={{ whiteSpace: 'nowrap', width: '80px', paddingTop: '2px', marginBottom: '8px' }}
                        id="nextweekbutton"
                        onClick={() => props.handleNextPayPeriod()}
                    >
                        {'>>'}
                    </Button>
                </div>

                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', minWidth: 200 }}>
                    <Button id="actions-dropdown" variant="contained" onClick={(e) => setAnchorEl(e.currentTarget)}>Bulk Actions</Button>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                        <MenuItem onClick={async() => {
                            setAnchorEl(null);
                            await handleBulkAction("approve");
                        }}>Approve</MenuItem>
                        <MenuItem onClick={async() => {
                            setAnchorEl(null);
                            await handleBulkAction("lock");
                        }}>Lock</MenuItem>
                        <MenuItem onClick={async() => {
                            setAnchorEl(null);
                            await handleBulkAction("unapprove");
                        }}>Unapprove</MenuItem>
                        <MenuItem onClick={async() => {
                            setAnchorEl(null);
                            await handleBulkAction("unlock");
                        }}>Unlock</MenuItem>
                        <MenuItem onClick={async() => {
                            setAnchorEl(null);
                            await handleBulkAction("generateMissingTimesheets");
                        }}>Generate Missing Timesheets</MenuItem>
                    </Menu>
                </div>
            </div>
            {props.isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', marginTop: '50px' }}>
                    <CircularProgress />
                </div>
            ) : (
                <div id='timesheets-summarytable-main h-96' style={{width: '100%'}} >
                    <div style={{ height: 'calc(100vh - 260px)', width: '100%' }} id="timesheets-summarytable-table">
                        <DataGridPro
                            dataSource={dataSource}
                            columns={columns}                             
                            checkboxSelection={true}
                            disableRowSelectionOnClick
                            rowSelectionModel={rowSelectionModel}
                            onRowSelectionModelChange={(newRowSelectionModel) => {
                                setRowSelectionModel(newRowSelectionModel);
                            }}
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                            pageSizeOptions={[25, 50, 100]}
                            pagination
                            sx={{ 
                                backgroundColor: '#F9F9F9',
                                '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell, & .MuiDataGrid-filler--pinnedLeft': {
                                    backgroundColor: '#F9F9F9',
                                },
                            }}
                            getCellClassName={(params) => {
                                if (params.field === 'timesheet_status') {
                                    if (params.value === "ACTIVE") {
                                        return 'active-cell';
                                    }
                                    else if (params.value === "SUBMITTED") {
                                        return 'submitted-cell';
                                    }
                                    else if (params.value === "APPROVED") {
                                        return 'approved-cell';
                                    }
                                    else if (params.value === "OPEN" || params.value === "Timesheet Not Created") {
                                        return 'open-cell';
                                    }
                                    else if (params.value === "ARCHIVED") {
                                        return 'archived-cell';
                                    }
                                }
                            }}
                            showToolbar
                        />
                    </div>
                </div>
            )}
        </div>
    );
}